import {React } from 'react';

export default function Tooltip({ message, children }) {
    return (
    <div class="group relative flex w-full">
        {children}
        <span class="absolute top-10 scale-0 transition-all rounded bg-black p-2 text-xs text-white group-hover:scale-100">{message}</span>
    </div>
    )
}